import React from "react";
import { ISVG } from "./interface";

const ComplianceReportIcon: React.FC<ISVG> = ({
  style = {},
  fill = "none",
  width = 24,
  height = 30,
  className = "",
  viewBox = "0 0 24 30",
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    fill={fill}
    viewBox={viewBox}
    className={`svg-icon ${className || ""}`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="compliance-icon">
      {/* Document outline in the background */}
      <path
        id="document-bg"
        d="M16.7771 0H0.529297V30H23.4705V6.69335L16.7771 0ZM17.294 3.01253L20.4579 6.17647H17.294V3.01253ZM2.294 28.2353V1.76471H15.5293V7.94118H21.7058V28.2353H2.294Z"
        fill="var(--tlx-cta-primary-default)"
        opacity="0.7"
      />
      {/* Shield with checkmark, badged over the document's lower-right corner */}
      <g transform="translate(8.7, 10.8) scale(0.65)">
        <path
          id="shield-check"
          d="M12 0L2 4V13C2 19.5 6.5 25.5 12 28C17.5 25.5 22 19.5 22 13V4L12 0ZM12 2.5L20 5.5V13C20 18.5 16.5 23.5 12 25.5C7.5 23.5 4 18.5 4 13V5.5L12 2.5ZM10.5 17L7 13.5L8.5 12L10.5 14L15.5 9L17 10.5L10.5 17Z"
          fill="var(--tlx-cta-primary-default)"
        />
      </g>
    </g>
  </svg>
);

export default ComplianceReportIcon;
